module.exports = __webpack_public_path__ + "static/media/jpis.8f3edda2.jpeg";